import { render, staticRenderFns } from "./ComplieAudio.vue?vue&type=template&id=4de8935e&scoped=true"
import script from "./ComplieAudio.vue?vue&type=script&lang=js"
export * from "./ComplieAudio.vue?vue&type=script&lang=js"
import style0 from "./ComplieAudio.vue?vue&type=style&index=0&id=4de8935e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de8935e",
  null
  
)

export default component.exports